import { useEffect, useState } from "react";
import axios from "axios";
import uuid from "react-uuid";
// import carouselMain from "../api/carousel/main/index.json"; // import .json
// import carouselSub from "../api/carousel/sub/index.json"; // import .json

// console.log("result:",result);
// console.log("result Type:",typeof result);
const slideInterval = 2000;
const todaysDate = new Date();
function showUntilChecker(imgUntil) {
    // console.log("imgUntil:",imgUntil);
    const imgDate = new Date(imgUntil);
    // console.log("imgDate:",imgDate ," >= ", todaysDate);
    if (imgDate >= todaysDate) {
        return true;
    } else {
        return false;
    }
}
const handleImageClick = (imgLink) => {
    window.open(imgLink, "_blank");
};

export default function BannerCarousel() {
    const [data_carousel, setData_carousel] = useState([]);
    const [renderedIndicators, setRenderedIndicators] = useState([]);
    const [renderedCarouselItem, setRenderedCarouselItem] = useState([]);
    const apiUrl = process.env.REACT_APP_API_URL;
    useEffect(() => {
        const fetchData = async () => {
            try {
                const renderedIndicators = [];
                const renderedCarouselItem = [];
                let x = 1;
                const carouselItems = [];
                const resultApi = await axios.get(`${apiUrl}carousel/sub/index.json`); // using api
                const result = resultApi.data; // using api
                // const result = carouselMain; // using import .json
                if (typeof result == "object" && result.length > 0) {
                    // eslint-disable-next-line
                    Object.keys(result).map((key) => {
                        const item = result[key];
                        // console.log("until: ", item);
                        if (showUntilChecker(item.imgUntil)) {
                            carouselItems.push(item);
                            if (renderedCarouselItem.length > 0) {
                                renderedCarouselItem.push(
                                    <div
                                        key={uuid()}
                                        className="carousel-item"
                                        data-bs-interval={slideInterval}
                                    >
                                        <img
                                            src={item.imgSrc}
                                            className="d-block w-100 imageCarousel"
                                            alt={item.imgAlt}
                                            onClick={() =>
                                                handleImageClick(item.imgLink)
                                            }
                                        />
                                        <div className="carousel-caption d-none d-md-block">
                                            <h5>{item.imgAlt}</h5>
                                            <p>{item.imgAlt}</p>
                                        </div>
                                    </div>
                                );
                            } else {
                                renderedCarouselItem.push(
                                    <div
                                        key={uuid()}
                                        className="carousel-item active"
                                        data-bs-interval={slideInterval}
                                    >
                                        <img
                                            src={item.imgSrc}
                                            className="d-block w-100 imageCarousel"
                                            alt={item.imgAlt}
                                            onClick={() =>
                                                handleImageClick(item.imgLink)
                                            }
                                        />
                                        <div className="carousel-caption d-none d-md-block">
                                            <h5>{item.imgAlt}</h5>
                                            <p>{item.imgAlt}</p>
                                        </div>
                                    </div>
                                );
                            }

                            if (renderedIndicators.length > 0) {
                                renderedIndicators.push(
                                    <button
                                        key={uuid()}
                                        type="button"
                                        data-bs-target="#carouselMainIndicators"
                                        data-bs-slide-to={x}
                                        aria-label={item.imgAlt}
                                    ></button>
                                );
                                x++;
                            } else {
                                renderedIndicators.push(
                                    <button
                                        key={uuid()}
                                        type="button"
                                        data-bs-target="#carouselMainIndicators"
                                        data-bs-slide-to="0"
                                        aria-label={item.imgAlt}
                                        className="active"
                                        aria-current="true"
                                    ></button>
                                );
                            }
                        }
                    });
                    setData_carousel(carouselItems);
                    setRenderedIndicators(renderedIndicators);
                    setRenderedCarouselItem(renderedCarouselItem);
                }
            } catch (e) {
                console.error("fetch ERROR: ", e);
            }
        };

        fetchData();

        // eslint-disable-next-line
    }, []);

    // console.log("data carousel: ", data_carousel);
    // console.log("renderedIndicators: ", renderedIndicators);
    // console.log("renderedCarouselItem: ", renderedCarouselItem);

    if (data_carousel.length > 0) {
        return (
            <div
                // key="carouselMain"
                id="carouselMainIndicators"
                className="carousel slide mt-4 shadow rounded-3"
                data-bs-ride="carousel"
            >
                <div className="carousel-indicators">{renderedIndicators}</div>
                <div className="carousel-inner">{renderedCarouselItem}</div>
                <button
                    className="carousel-control-prev"
                    type="button"
                    data-bs-target="#carouselMainIndicators"
                    data-bs-slide="prev"
                >
                    <span
                        className="carousel-control-prev-icon"
                        aria-hidden="true"
                    ></span>
                    <span className="visually-hidden">Previous</span>
                </button>
                <button
                    className="carousel-control-next"
                    type="button"
                    data-bs-target="#carouselMainIndicators"
                    data-bs-slide="next"
                >
                    <span
                        className="carousel-control-next-icon"
                        aria-hidden="true"
                    ></span>
                    <span className="visually-hidden">Next</span>
                </button>
            </div>
        );
    }
}

export function SubCarousel(props) {
    const carouselName = props.name;
    const [data_carousel, setData_carousel] = useState([]);
    const [renderedIndicators, setRenderedIndicators] = useState([]);
    const [renderedCarouselItem, setRenderedCarouselItem] = useState([]);
    const apiUrl = process.env.REACT_APP_API_URL;
    useEffect(() => {
        const fetchData = async () => {
            try {
                const renderedIndicators = [];
                const renderedCarouselItem = [];
                let x = 1;
                const carouselItems = [];
                const resultApi = await axios.get(`${apiUrl}carousel/sub/index.json`); // using api
                const result = resultApi.data; // using api
                // const result = carouselSub; // using import .json
                if (typeof result == "object" && result.length > 0) {
                    // eslint-disable-next-line
                    Object.keys(result).map((key) => {
                        const item = result[key];
                        // console.log("until: ", item);
                        if (showUntilChecker(item.imgUntil)) {
                            carouselItems.push(item);
                            if (renderedCarouselItem.length > 0) {
                                renderedCarouselItem.push(
                                    <div
                                        key={uuid()}
                                        className="carousel-item"
                                        data-bs-interval={slideInterval}
                                    >
                                        <img
                                            src={item.imgSrc}
                                            className="d-block w-100 imageCarousel"
                                            alt={item.imgAlt}
                                            onClick={() =>
                                                handleImageClick(item.imgLink)
                                            }
                                        />
                                        <div className="carousel-caption d-none d-md-block">
                                            <h5>{item.imgAlt}</h5>
                                            <p>{item.imgAlt}</p>
                                        </div>
                                    </div>
                                );
                            } else {
                                renderedCarouselItem.push(
                                    <div
                                        key={uuid()}
                                        className="carousel-item active"
                                        data-bs-interval={slideInterval}
                                    >
                                        <img
                                            src={item.imgSrc}
                                            className="d-block w-100 imageCarousel"
                                            alt={item.imgAlt}
                                            onClick={() =>
                                                handleImageClick(item.imgLink)
                                            }
                                        />
                                        <div className="carousel-caption d-none d-md-block">
                                            <h5>{item.imgAlt}</h5>
                                            <p>{item.imgAlt}</p>
                                        </div>
                                    </div>
                                );
                            }

                            if (renderedIndicators.length > 0) {
                                renderedIndicators.push(
                                    <button
                                        key={uuid()}
                                        type="button"
                                        data-bs-target={`#${carouselName}Indicators`}
                                        data-bs-slide-to={x}
                                        aria-label={item.imgAlt}
                                    ></button>
                                );
                                x++;
                            } else {
                                renderedIndicators.push(
                                    <button
                                        key={uuid()}
                                        type="button"
                                        data-bs-target={`#${carouselName}Indicators`}
                                        data-bs-slide-to="0"
                                        aria-label={item.imgAlt}
                                        className="active"
                                        aria-current="true"
                                    ></button>
                                );
                            }
                        }
                    });
                    setData_carousel(carouselItems);
                    setRenderedIndicators(renderedIndicators);
                    setRenderedCarouselItem(renderedCarouselItem);
                }
            } catch (e) {
                console.error("fetch ERROR: ", e);
            }
        };

        fetchData();
        // eslint-disable-next-line
    }, []);
    // console.log("data carousel: ", data_carousel);
    // console.log("renderedIndicators: ", renderedIndicators);
    // console.log("renderedCarouselItem: ", renderedCarouselItem);

    if (data_carousel.length > 0) {
        return (
            <div
                // key="carouselMain"
                id={`${carouselName}Indicators`}
                className="carousel slide mt-4 shadow rounded-3"
                data-bs-ride="carousel"
            >
                <div className="carousel-indicators">{renderedIndicators}</div>
                <div className="carousel-inner">{renderedCarouselItem}</div>
                <button
                    className="carousel-control-prev"
                    type="button"
                    data-bs-target={`#${carouselName}Indicators`}
                    data-bs-slide="prev"
                >
                    <span
                        className="carousel-control-prev-icon"
                        aria-hidden="true"
                    ></span>
                    <span className="visually-hidden">Previous</span>
                </button>
                <button
                    className="carousel-control-next"
                    type="button"
                    data-bs-target={`#${carouselName}Indicators`}
                    data-bs-slide="next"
                >
                    <span
                        className="carousel-control-next-icon"
                        aria-hidden="true"
                    ></span>
                    <span className="visually-hidden">Next</span>
                </button>
            </div>
        );
    }
}
